const RedacaoList = () => import("~/components/Views/Prova/Redacao/List");
const RedacaoNew = () => import("~/components/Views/Prova/Redacao/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Conteúdo", link: "" }
];

export const redacao = [
  {
    path: "conteudo/redacao",
    component: RedacaoList,
    name: "Redação",
    meta: {
      title: "Redação",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "conteudo/redacao/new",
    component: RedacaoNew,
    name: "Nova Redação",
    meta: {
      title: "Nova Redação",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "conteudo/redacao/:id",
    component: RedacaoNew,
    name: "Alterar Redação",
    meta: {
      title: "Alterar Redação",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/conteudo/redacao.js